import { useEffect, useMemo, useState } from 'react'
import { Table, Space, Button, Form, Input, Modal, Select, DatePicker, TreeSelect, Switch } from 'antd'
import { SearchOutlined, RedoOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo, baseAxiosComplete } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

type fetchParams = {
    store_id: string | undefined,
    activity_name: string | undefined,
    status: number | undefined
}

export default function ConfigActivityList() {

    let paginatioTml = {
        current: 1,
        pageSize: 8,
        total: 0
    }

    let otherParamsTml = {
        store_id: undefined,
        activity_name: undefined,
        status: undefined
    }

    const [pagination, setPagination] = useState<pagination>(paginatioTml)
    const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)

    const [tableList, setTableList] = useState<any[]>([])
    const [optionStoreData, setOptionStoreData] = useState<{}[]>([])
    const [optionItemData, setOptionItemData] = useState<{}[]>([])

    const [addVisible, setAddVisible] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询门店列表
        baseAxiosNoInfo('/global/store_list').then((response: any) => {
            if (response) {
                setOptionStoreData(response)
            }
        })

        // 查询产康单项列表
        baseAxiosNoInfo.get('/chankang_center/item_single/select_list').then((response: any) => {
            if (response) {
                response.forEach((el: { singles: any[], id: string }) => {
                    el.singles.forEach(el2 => {
                        if (el2.item_id) {
                            Object.assign(el2, { item_id: el2.item_id, standard_times: el2.standard_times })
                        }
                    })
                })

                translateToTreeData(response)
            }
        })

        fetch({ pagination, otherParams })
    }, [pagination.current])

    const translateToTreeData = (data: any) => {
        setOptionItemData(
            data.map((el: any) => ({
                title: el.item_type_name, // '产康分类1'
                value: el.item_type_id, // '0-0'
                key: el.item_type_id, // '0-0'
                disabled: el.singles.length ? false : true,
                children: el.singles.map((el: { item_id: string, item_name: string }) => ({
                    title: el.item_name, // '项目1'
                    value: el.item_id, //  '0-0-0'
                    key: el.item_id, // '0-0-0'
                }))
            }))
        )
    }

    const handleQueryChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(otherParams)
        params[attr] = value

        setOtherParams(params)
    }

    const handleSearch = () => {
        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...otherParams }

        axiosTable.get('/yuezi_center/marketing_activity/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setTableList(response.records)
            }
        })
    }

    const resetForm = () => {
        setOtherParams(otherParamsTml)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, otherParams: otherParamsTml })
    }

    const onAddFinish = (values: any) => {
        values.activity_start_date = values.date[0].format('YYYY-MM-DD')
        values.activity_end_date = values.date[1].format('YYYY-MM-DD')

        baseAxiosComplete.post('/yuezi_center/marketing_activity/add', { id: activeRecord.id, ...values }).then((res: any) => {
            if (res.status === 0) {
                resetForm()
                setAddVisible(false)
            }
        })
    }

    let activeRecord: any = {}
    let optionStore = optionStoreData.map((el: any) => (<Option value={el.store_id} key={el.store_id}>{el.store_name}</Option>))

    return (<div className="common-page">
        {/* 月子中心 -> 月子配置管理 -> 营销活动管理 */}
        <BreadCrumb position={['月子中心', '营销活动管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div className="fl" style={{ marginRight: 12, marginBottom: 12 }}>
                    <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleQueryChange(value, 'store_id') }} />
                </div>
                <Input className="fl" style={{ width: '120px', marginRight: 12, marginBottom: 12 }} value={otherParams.activity_name} placeholder="活动名称" onChange={(e: { target: { value: string } }) => { handleQueryChange(e.target.value, 'activity_name') }} />

                <Select allowClear virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="活动状态" value={otherParams.status} onChange={(v: number) => { handleQueryChange(v, 'is_use') }}>
                    <Option value={1} key={1}>待开启</Option>
                    <Option value={2} key={2}>开启中</Option>
                    <Option value={3} key={3}>已结束</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
                {permission.includes('添加') && <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => { setAddVisible(true) }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={tableList} bordered={true} scroll={{ x: 'max-content' }} pagination={pagination} onChange={handleTableChange}>
                <Column title="门店名称" dataIndex="store_name" key="store_name" />
                <Column title="活动名称" dataIndex="activity_name" key="activity_name" />
                <Column title="开始日期" dataIndex="activity_start_date" key="activity_start_date" />
                <Column title="结束日期" dataIndex="activity_end_date" key="activity_end_datec" />
                <Column title="活动方案" dataIndex="activity_plan" key="activity_plan" render={
                    plan => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = plan.split(',');

                        for (let i = 0; i < content_list.length; i++) {
                            if (i === 0) {
                                result = content_list[i];

                            } else {
                                result = <span>{result}{br}{content_list[i]}</span>;
                            }
                        }

                        return <div>{result}</div>;
                    }}
                />
                <Column title="赠送项目" dataIndex="activity_item_list" key="activity_item_list" width={200} render={(itemList) => {
                    return itemList.map((el: { item_name: String, item_count: String }) => (
                        <div>{el.item_name}{'*'}{el.item_count}{"；"}</div>
                    ))
                }} />
                <Column title="活动状态" dataIndex="activity_status" key="activity_status" render={(text, record: any) => (
                    <Space size="middle">
                        <Switch checked={record.activity_status == undefined || record.activity_status == null || record.activity_status == 1 || record.activity_status == 3 ? false : true} onClick={() => {
                            baseAxiosComplete.post('/yuezi_center/marketing_activity/switch_status', {
                                id: record.activity_id,
                                status: record.activity_status == 1 ? 2 : record.activity_status == 2 ? 3 : record.activity_status == 3 ? 2 : 1
                            }).then((res: any) => {
                                resetForm()
                            })
                        }} />
                    </Space>
                )} />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
            </Table>
        </div>

        {/* 月子中心 -> 月子配置管理 -> 营销活动管理 -> 新增 */}
        <Modal title="添加活动" visible={addVisible} width={600} footer={false} onCancel={() => { setAddVisible(false) }} destroyOnClose={true}>
            <Form {...formItemLayout} name="basic" onFinish={onAddFinish}>
                <Form.Item label="活动门店" name="store_id_list" rules={[{ required: true, message: '必须选择活动门店' }]} >
                    <Select virtual={false} mode="multiple">{optionStore}</Select>
                </Form.Item>

                <Form.Item label="活动名称" name="activity_name" rules={[{ required: true, message: '必须填写活动名称' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="活动日期" name="date" rules={[{ required: true, message: '必须选择活动日期' }]}>
                    <RangePicker style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item label="活动方案">
                    <Form.List name="activity_plan_list">
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item required={false} key={field.key}>
                                        <Form.Item {...field} validateTrigger={['onChange', 'onBlur']} rules={[{ required: true, message: "必须填写活动方案" }]} noStyle>
                                            <Input placeholder="活动方案" style={{ width: '90%' }} />
                                        </Form.Item>

                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined style={{ marginLeft: 10 }}
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}

                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} style={{ width: '45%' }} icon={<PlusOutlined />} >活动方案</Button>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item label="赠送产康">
                    <Form.List name="chankang_item_list">
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                {fields.map((field, index) => (
                                    <Form.Item required={false} key={field.key}>
                                        <Form.Item {...field} label="item_id" name={[field.name, 'item_id']} rules={[{ required: true, message: "必须选择项目" }]} noStyle>
                                            <TreeSelect showSearch treeData={optionItemData} treeCheckable={true} style={{ width: '65%' }} filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)} />
                                        </Form.Item>

                                        <Form.Item label="item_count" name={[field.name, 'item_count']} validateTrigger={['onChange', 'onBlur']} rules={[{ required: true, message: "必须填写项目次数" }]} noStyle>
                                            <Input placeholder="次数" style={{ marginLeft: 10, width: '20%' }} />
                                        </Form.Item>

                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined style={{ marginLeft: 10 }}
                                                className="dynamic-delete-button"
                                                onClick={() => remove(field.name)}
                                            />
                                        ) : null}
                                    </Form.Item>
                                ))}

                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()} style={{ width: '45%' }} icon={<PlusOutlined />} >赠送产康</Button>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}